module.exports = __webpack_public_path__ + "img/klara-avsenik-1406514-unsplash.9c92cbb7.jpg";